module.exports = __webpack_public_path__ + "img/banner-line_big-short_dark.bc42200c.png";